import { ReactNode } from 'react'
import { cn } from '@/ui/utils/style'

interface ActionsCellWrapperProps {
  children: ReactNode
  className?: string
}

export function ActionsCell({ children, className }: ActionsCellWrapperProps) {
  return (
    <div
      className={cn("mt-4 flex justify-end md:mt-0", className)}
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <div className="flex w-full justify-end gap-2">{children}</div>
    </div>
  )
}
